module.exports = __webpack_public_path__ + "static/stairs-3fdd9d49417c6e16f483116ded8ed25a.jpg";